import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { ReactNode } from 'react';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import useSignIn from '../../hooks/useSignIn';

const AuthGuardProvider = ({
  allowUnAuthenticated,
  children,
}: {
  children: ReactNode;
  allowUnAuthenticated?: boolean;
}) => {
  const { signIn } = useSignIn();
  const router = useRouter();
  // When the new auth experience is on, send logged-out users to the in-app
  // /login screen instead of the legacy Azure B2C hosted flow.
  const newAuth = useFeatureFlag('US_AUTH');
  const session = useSession();
  if (allowUnAuthenticated) return <>{children}</>;
  if (session.status === 'loading') return <>{children}</>;
  if (session.status === 'authenticated') return <>{children}</>;
  if (session.status === 'unauthenticated') {
    if (newAuth) {
      router.replace(`/login?redirect=${encodeURIComponent(router.asPath)}`);
    } else {
      signIn();
    }
  }
  return <></>;
};

export default AuthGuardProvider;
